import { useLocation } from 'react-router-dom';
import { paths } from '@/constants';
import { useProjectId } from '@/hooks';
import { ImportScriptButton } from './ImportScriptButton';
import { ImportScriptModal } from './ImportScriptModal';

export const ImportScript = () => {
    const project_id = useProjectId();
    const location = useLocation();

    const isVisible = ![
        paths.profile.index,
        paths.company.index,
        paths.company.projects,
        paths.employees.index,
        paths.employees.invite,
    ].find(p => p === location.pathname);

    return project_id && isVisible ? (
        <>
            <ImportScriptButton />
            <ImportScriptModal />
        </>
    ) : null;
};
